import axios from 'axios'

export const competition = {
  namespaced: true,
  state: {
    Seasons: [],
    Series: [],
    Teams: [],
    Playweeks: [],
    Matches: [],
    MatchLoading: false,
    MatchMessage: '',
    SelectedProvinceId: 0,
    SelectedClubId: 0,
    SelectedSeason: 0,
    SelectedSerie: null,
    SelectedTeam: null,
    SelectedWeek: null
  },
  getters: {
    Seasons: state => state.Seasons,
    Series: state => state.Series,
    Teams: state => state.Teams,
    Playweeks: state => state.Playweeks,
    Matches: state => state.Matches,
    MatchLoading: state => state.MatchLoading,
    MatchMessage: state => state.MatchMessage,
    SelectedProvinceId: state => state.SelectedProvinceId,
    SelectedClubId: state => state.SelectedClubId,
    SelectedSeason: state => state.SelectedSeason,
    SelectedSerie: state => state.SelectedSerie,
    SelectedTeam: state => state.SelectedTeam,
    SelectedWeek: state => state.SelectedWeek
  },
  mutations: {
    InvalidateCompetition (state) {
      state.Series = []
      state.Teams = []
      state.Matches = []
      state.SelectedSerie = null
      state.SelectedTeam = null
    },
    SelectedProvinceIdSet (state, payload) {
      state.SelectedProvinceId = payload.province_id
      state.SelectedClubId = 0
    },
    SelectedClubIdSet (state, payload) {
      state.SelectedClubId = payload.club_id
      state.SelectedProvinceId = 0
    },
    SelectedSerieSet (state, serie) {
      state.SelectedSerie = serie
    },
    SelectedTeamSet (state, team) {
      state.SelectedTeam = team
    },
    SelectedWeekSet (state, playweek) {
      state.SelectedWeek = playweek
    },
    SeasonsSet (state, payload) {
      state.Seasons = payload.data
    },
    SeriesSet (state, payload) {
      state.Series = payload.data
    },
    TeamsSet (state, payload) {
      state.Teams = payload.data
    },
    PlayweeksSet (state, payload) {
      state.Playweeks = payload.data
    },
    MatchMessageSet (state, payload) {
      state.MatchMessage = payload
      state.MatchLoading = payload !== ''
    },
    MatchesSet (state, payload) {
      state.Matches = payload.data
    }
  },
  actions: {
    SetSelectedProvinceId (context, province_id) {
      if (context.state.SelectedProvinceId !== province_id) {
        context.commit('InvalidateCompetition')
        context.commit('SelectedProvinceIdSet', {province_id: province_id})
        if (province_id > 0) {
          context.dispatch('LoadCompetition', {})
        }
      }
    },
    SetSelectedClubId (context, club_id) {
      if (context.state.SelectedClubId !== club_id) {
        context.commit('InvalidateCompetition')
        context.commit('SelectedClubIdSet', {club_id: club_id})
        if (club_id > 0) {
          context.dispatch('LoadCompetition', {})
        }
      }
    },
    SetSelectedSerie (context, serie) {
      context.commit('SelectedSerieSet', serie)
    },
    SetSelectedTeam (context, team) {
      context.commit('SelectedTeamSet', team)
    },
    SetSelectedWeek (context, week) {
      context.commit('SelectedWeekSet', week)
    },
    LoadCompetition (context) {
      context.commit('MatchMessageSet', 'Loading Competition')
      var requirements = [
        context.dispatch('LoadSeries', {}),
        context.dispatch('LoadTeams', {}),
        context.dispatch('LoadPlayweeks', {}),
        context.dispatch('LoadMatches', {})
      ]
      requirements.reduce((p, fn) => p.then(fn), Promise.resolve())
    },
    LoadSeasons (context) {
      axios.post(context.rootState.vaconfig.ServerURL + 'seasons/listseasons/', {})
        .then((res) => {
          if (res != null) {
            context.commit('SeasonsSet', res.data)
          }
        }).catch(() => {
        })
    },
    LoadSeries (context) {
      return new Promise((resolve, reject) => {
        axios.post(context.rootState.vaconfig.ServerURL + 'series/listseries/', {data: {province_id: context.state.SelectedProvinceId, club_id: context.state.SelectedClubId}})
          .then((res) => {
            if (res != null) {
              context.commit('SeriesSet', res.data)
              resolve()
            }
          }).catch(() => {
          })
      })
    },
    LoadPlayweeks (context) {
      return new Promise((resolve, reject) => {
        if (context.state.Playweeks.length > 0) {
          resolve()
        } else {
          return axios.post(context.rootState.vaconfig.ServerURL + 'seasons/listplayweeks/', {data: {season_id: context.state.SelectedSeasonId}})
            .then((res) => {
              if (res != null) {
                context.commit('PlayweeksSet', res.data)
                resolve()
              }
            }).catch(() => {
            })
        }
      })
    },
    LoadTeams (context) {
      return new Promise((resolve, reject) => {
        return axios.post(context.rootState.vaconfig.ServerURL + 'teams/listteams/', {data: {province_id: context.state.SelectedProvinceId, club_id: context.state.SelectedClubId}})
          .then((res) => {
            if (res != null) {
              context.commit('TeamsSet', res.data)
              resolve()
            }
          }).catch(() => {
          })
      })
    },
    LoadMatches (context) {
      context.commit('MatchesSet', {data: []})
      let filter = {
        province_id: context.state.SelectedProvinceId,
        club_id: context.state.SelectedClubId
      }
      if (context.state.SelectedSerie && context.state.SelectedSerie.serie_id > 0) {
        filter.serie_id = context.state.SelectedSerie.serie_id
      }
      if (context.state.SelectedTeam && context.state.SelectedTeam.team_id > 0) {
        filter.team_id = context.state.SelectedTeam.team_id
      }
      if (context.state.SelectedWeek && context.state.SelectedWeek.season_playweek_id > 0) {
        filter.date_start = context.state.SelectedWeek.season_playweek_date_monday
        filter.date_end = context.state.SelectedWeek.season_playweek_date_sunday
      }
      if (Object.keys(filter).length === 2) {
        context.commit('MatchMessageSet', 'Gebruik een filter a.u.b.')
      } else {
        context.commit('MatchMessageSet', 'Bezig met ophalen...')
        return new Promise((resolve, reject) => {
          return axios.post(context.rootState.vaconfig.ServerURL + 'matches/listmatches/', {data: filter})
            .then((res) => {
              if (res != null) {
                context.commit('MatchesSet', res.data)
                context.commit('MatchMessageSet', '')
                resolve()
              }
            }).catch(() => {
            })
        })
      }
    }
  }
}

export default {
  competition
}



// WEBPACK FOOTER //
// ./src/store/competition.js